import React from 'react'
import { LocationOn } from '@material-ui/icons'
import { Button, Tooltip } from '@material-ui/core'
import { useLiterals } from '~/components/Literals'
import { formatDistance } from '~/utils'

const Distance = ({ distance, handleClickRota }) => {
  const { getLiteral } = useLiterals()

  return (
    <Tooltip title={getLiteral('2474')}>
      <Button
        size="small"
        variant="text"
        startIcon={<LocationOn style={{ fontSize: 16, color: '#1E2361' }} />}
        onClick={handleClickRota}
        component="a"
        target="_blank"
        style={{ height: 'fit-content', fontSize: 14, whiteSpace: 'nowrap' }}
      >
        <span>{formatDistance(distance)}</span>
      </Button>
    </Tooltip>
  )
}

export default Distance
